import { initializeApp } from "firebase/app"; 
import { getFirestore } from "firebase/firestore"; 

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBhsT94vO9Pxzp_WPTDF7lyeOroDlT44D4",
  authDomain: "wisdom-office.firebaseapp.com",
  projectId: "wisdom-office",
  storageBucket: "wisdom-office.firebasestorage.app",
  messagingSenderId: "654834071808",
  appId: "1:654834071808:web:69da2e4264e060cf2e9be5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
export { db };